import React, { useState, useRef , useEffect} from "react";

import { Button } from "primereact/button";
import SidebarDatacount from "./SidebarDatacount";
import MenuSuspenso from "./pages/MenuSuspenso";

import { useLocalStorage } from 'primereact/hooks';

import { useLocation } from 'react-router-dom';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';


export default function Layout(props) {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const {children}  = props
    const [theme, setTheme] = useLocalStorage('theme', 'selectedTheme');
    const location = useLocation();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
            // Função que será chamada quando o tamanho da janela mudar
            const handleResize = () => {
                setWindowWidth(window.innerWidth);
            };
    
            // Adiciona o listener de resize
            window.addEventListener('resize', handleResize);
    
            // Limpeza do evento quando o componente for desmontado
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, []);
    
        // Lógica para verificar se a tela é menor que o tamanho de um tablet
        const isMobile = windowWidth <= 768; // Menor ou igual a 768px


    const {
        userName,
        tipoAcesso,
        empresa,
        dataEmpresa,
        dataBase,
        habilitarcollector,
        habilitarinventory
      } = location.state || {};
     

    const start = <Button icon="pi pi-cog" onClick={() => setVisible(!visible)} className="p-button-text" />;
    const toastBottomCenter = useRef(null);


    const showMessage = (event, severity) => {
        const label = event.target.innerText;

        toastBottomCenter.current.show({ severity: severity, summary: label, detail: label, life: 3000 });
    };

    
    return (
        <div className="flex flex-column h-screen page page-enter" >
            {loading || props.loading ? <ProgressBar
                mode="indeterminate" 
                style={{ height: '6px', zIndex :'9999', borderRadius : '0px' }} 
                className="fixed top-0 left-0 w-full"                 
                 ></ProgressBar> : null }
            <ConfirmDialog/>
            <Toast ref={toastBottomCenter} position="center" />
            {/* Barra Superior */}
            

            {/* Menu Lateral */}
            <SidebarDatacount 
                visible = {visible} 
                userName = {userName}
                setLoading={(op)=>setLoading(op)}
                tipoAcesso= {tipoAcesso}
                empresa= {empresa}
                dataEmpresa= {dataEmpresa}
                showMessage = {(event, severity)=>showMessage(event, severity)}
                dataBase= {dataBase}
                habilitarcollector= {habilitarcollector}
                habilitarinventory = {habilitarinventory}
                setVisible={() => setVisible(false)} 
                
                />
            <MenuSuspenso  
                model={[]} 
                setVisible={() => setVisible(true)} 
                start={start}
                isMobile ={windowWidth <= 768}
                userName = {userName}
                tipoAcesso= {tipoAcesso}
                setLoading={(op)=>setLoading(op)}
                empresa= {empresa}
                dataEmpresa= {dataEmpresa}
                dataBase= {dataBase}
                habilitarcollector= {habilitarcollector}
                habilitarinventory = {habilitarinventory}
                showMessage = {(event, severity)=>showMessage(event, severity)}
                className="bg-primary text-white px-3 py-2 shadow-2" />
            {/* Conteúdo Principal */}
          

                <div
                    className="flex-grow-1"
                    style={{
                        overflowY: 'auto',
                        width :isMobile ? '100%' : '89.8%', 
                        height : '50px',
                        marginLeft: isMobile ? '0' : '195px',  // Se for mobile, sem margem; caso contrário, a margem da sidebar
                        paddingLeft: '0px',
                        paddingRight : '0px',
                        marginTop : '90px',
                        position :'relative'
                    }}
                    >
                   
                   {children}
                </div>
        </div>
    );
}
